(function () {
  function reveal(scope) {
    var items = Array.prototype.slice.call((scope || document).querySelectorAll('[data-cl-reveal]'));
    if (!items.length) return;
    document.documentElement.classList.add('cl-motion-ready');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (item) { observer.observe(item); });
  }
  function init(scope) { reveal(scope || document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

(function () {
  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function setStage(stage, tiltX, tiltY, shiftX, shiftY, glareX, glareY) {
    stage.style.setProperty('--cl-tilt-x', tiltX.toFixed(2) + 'deg');
    stage.style.setProperty('--cl-tilt-y', tiltY.toFixed(2) + 'deg');
    stage.style.setProperty('--cl-shift-x', shiftX.toFixed(2) + 'px');
    stage.style.setProperty('--cl-shift-y', shiftY.toFixed(2) + 'px');
    stage.style.setProperty('--cl-glare-x', glareX.toFixed(1) + '%');
    stage.style.setProperty('--cl-glare-y', glareY.toFixed(1) + '%');
  }

  function initBuildingTilt(scope) {
    var stage = (scope || document).querySelector('[data-cl-building-stage]');
    if (!stage || stage.dataset.clTiltBound === 'true') return;
    stage.dataset.clTiltBound = 'true';

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      setStage(stage, 0, -2, 0, 0, 50, 42);
      return;
    }

    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var animationFrame = 0;

    if (finePointer) {
      stage.addEventListener('pointermove', function (event) {
        var bounds = stage.getBoundingClientRect();
        var horizontal = clamp((event.clientX - bounds.left) / bounds.width, 0, 1);
        var vertical = clamp((event.clientY - bounds.top) / bounds.height, 0, 1);
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(function () {
          setStage(
            stage,
            4 - vertical * 8,
            -8 + horizontal * 16,
            (horizontal - 0.5) * 9,
            (vertical - 0.5) * 7,
            horizontal * 100,
            vertical * 100
          );
        });
      }, { passive: true });

      stage.addEventListener('pointerleave', function () {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(function () {
          setStage(stage, 2, -6, 0, 0, 48, 36);
        });
      }, { passive: true });
      return;
    }

    var scrollSurface = document.querySelector('.page-wrapper');
    var scrollTarget = scrollSurface && scrollSurface.scrollHeight > scrollSurface.clientHeight + 2 ? scrollSurface : window;
    var pending = false;
    function updateFromScroll() {
      pending = false;
      var bounds = stage.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var progress = clamp((viewportHeight - bounds.top) / (viewportHeight + bounds.height), 0, 1);
      setStage(stage, 1 + progress * 2.5, -7 + progress * 12, 0, (progress - 0.5) * 10, 52, 30 + progress * 35);
    }
    function requestUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(updateFromScroll);
    }
    scrollTarget.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  }

  function init(scope) {
    initBuildingTilt(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

(function () {
  function initScrollProgress() {
    if (document.querySelector('.cl-scroll-progress')) return;

    var bar = document.createElement('div');
    bar.className = 'cl-scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var scroller = document.querySelector('.page-wrapper');
    var target = scroller || window;
    var ticking = false;

    function update() {
      var current = scroller ? scroller.scrollTop : window.scrollY;
      var maximum = scroller
        ? scroller.scrollHeight - scroller.clientHeight
        : document.documentElement.scrollHeight - window.innerHeight;
      var progress = maximum > 0 ? Math.min(1, Math.max(0, current / maximum)) : 0;
      bar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    target.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollProgress, { once: true });
  } else {
    initScrollProgress();
  }
})();

(function () {
  var translations = {
    nl: {
      'language.label': 'Taal',
      'hero.kicker': 'Klaar voor de sleuteloverdracht',
      'hero.title': 'Woningen klaar',
      'hero.emphasis': 'om op te leveren, verhuren of over te dragen.',
      'hero.body': '<p>Na een verhuis, renovatie of bouwwerf maakt Clean Living appartementen en woningen grondig schoon voor de plaatsbeschrijving of oplevering.</p>',
      'hero.primary': 'Vraag snel een offerte',
      'hero.appointment': 'Plan de schoonmaak',
      'hero.offer.label': 'eerste proefappartement',
      'hero.scope': 'Einde huur · Na bouwwerken',
      'hero.contact.email': 'E-mail',
      'hero.contact.phone': 'Telefoon',
      'hero.contact.hours': 'Openingsuren',
      'hero.contact.hours.value': '10:00 – 18:00',
      'hero.trust.1': 'Snelle offerte',
      'hero.trust.2': 'Flexibele planning',
      'hero.trust.3': 'Eindcontrole',
      'hero.image.alt': 'Nieuw appartementsgebouw waarvan de woningen door Clean Living opleverklaar worden gemaakt',
      'services.title': 'Twee sleutelmomenten. Eén volledige opleveringsschoonmaak.',
      'services.intro': 'Eindschoonmaak na huur voor een vlotte sleuteloverdracht en schoonmaak na bouw of renovatie voor opleverklare woningen.',
      'services.1.kicker': 'Einde huur',
      'services.1.title': 'Klaar voor de plaatsbeschrijving.',
      'services.1.body': '<p>Na het vertrek van een huurder maken we de lege woning grondig schoon voor de sleuteloverdracht of de volgende bewoner.</p>',
      'services.1.feature.1': 'Keuken en sanitair',
      'services.1.feature.2': 'Vloeren en plinten',
      'services.1.feature.3': 'Bereikbare ramen',
      'services.1.feature.4': 'Lege kasten',
      'services.2.kicker': 'Na bouw of renovatie',
      'services.2.title': 'Klaar voor oplevering.',
      'services.2.body': '<p>We verwijderen fijn stof, sporen en resten na bouw of renovatie, vóór de appartementen worden opgeleverd.</p>',
      'services.2.feature.1': 'Fijn bouwstof',
      'services.2.feature.2': 'Sporen van werken',
      'services.2.feature.3': 'Vloeren en glas',
      'services.2.feature.4': 'Eindcontrole',
      'services.3.kicker': 'Grondige afwerking',
      'services.3.title': 'Zichtbare details maken het verschil.',
      'services.3.body': '<p>We ontvetten, ontkalken en reinigen de zones die de eindindruk van de woning bepalen.</p>',
      'services.3.feature.1': 'Keuken',
      'services.3.feature.2': 'Badkamer',
      'services.3.feature.3': 'Deuren en schakelaars',
      'services.3.feature.4': 'Zichtbare afwerking',
      'services.4.kicker': 'Volledige gebouwen',
      'services.4.title': 'Meerdere woningen, één duidelijk plan.',
      'services.4.body': '<p>Voor projectontwikkelaars en aannemers coördineren we de eindschoonmaak per lot en volgens de opleverdata.</p>',
      'services.4.feature.1': 'Planning per lot',
      'services.4.feature.2': 'Opleverdata',
      'services.4.feature.3': 'Controle per woning',
      'services.4.feature.4': 'Eén aanspreekpunt',
      'entrance.kicker': 'De sleuteloverdracht komt dichterbij',
      'entrance.title': 'Een schone woning',
      'entrance.emphasis': 'tot in de details.',
      'entrance.body': 'We bereiden de zichtbare en meest veeleisende zones voor op de plaatsbeschrijving, verhuur of oplevering.',
      'entrance.item.1': 'Keuken & sanitair',
      'entrance.item.2': 'Vloeren & plinten',
      'entrance.item.3': 'Ramen & deuren',
      'entrance.image.alt': 'Twee Clean Living-medewerkers die een woning voorbereiden op de sleuteloverdracht',
      'entrance.caption': 'Klaar voor de plaatsbeschrijving of oplevering.',
      'method.image.alt': 'Clean Living-team tijdens een schoonmaak na bouwwerken',
      'method.kicker': 'Onze werkwijze',
      'method.title': 'Een team dat elke woning voorbereidt',
      'method.emphasis': 'op de volgende stap.',
      'method.body': '<p>We werken volgens uw sleutel- of opleverdatum, met een duidelijke scope en een zorgvuldige controle van de afwerking.</p>',
      'method.step.1.title': 'Adres, foto’s & datum',
      'method.step.1.body': 'U deelt de woning, de huidige staat en uw deadline.',
      'method.step.2.title': 'Scope & prijs',
      'method.step.2.body': 'We bevestigen duidelijk de zones, de interventie en de offerte.',
      'method.step.3.title': 'Schoonmaak & controle',
      'method.step.3.body': 'Ons team maakt de woning schoon en controleert de zichtbare afwerking.',
      'routine.kicker': 'Een volledige opleveringsschoonmaak',
      'routine.title': 'Van bouwstof tot sleutelklare woning.',
      'routine.intro': 'Een gestructureerde interventie om een woning proper over te dragen, te verhuren of op te leveren.',
      'routine.1.title': 'Ontstoffen',
      'routine.1.body': 'Muren, plinten, deuren en oppervlakken.',
      'routine.2.title': 'Ontvetten',
      'routine.2.body': 'Keuken, sanitair en hardnekkige sporen.',
      'routine.3.title': 'Reinigen',
      'routine.3.body': 'Vloeren en bereikbare beglazing.',
      'routine.4.title': 'Controleren',
      'routine.4.body': 'Kamer per kamer voor de sleuteloverdracht.',
      'booking.kicker': 'Plan de interventie',
      'booking.title': 'Kies het moment',
      'booking.emphasis': 'dat bij uw deadline past.',
      'booking.intro': 'Stel een datum en uur voor vóór uw plaatsbeschrijving of oplevering. Voor professionele projecten krijgt het eerste proefappartement 50% korting.',
      'booking.confirmation': 'Het tijdstip is definitief nadat ons team het heeft bevestigd.',
      'booking.date': 'Gewenste datum',
      'booking.time': 'Gewenst uur',
      'booking.service': 'Dienst',
      'booking.service.placeholder': 'Kies een dienst',
      'booking.service.moveout': 'Einde huur / verhuis',
      'booking.service.construction': 'Na bouw / renovatie',
      'booking.service.multiunit': 'Meerdere woningen op te leveren',
      'booking.size': 'Geschatte oppervlakte',
      'booking.size.placeholder': 'Bijv. 85 m²',
      'booking.name': 'Naam',
      'booking.phone': 'Telefoon',
      'booking.email': 'E-mailadres',
      'booking.note': 'Extra opmerking',
      'booking.optional': 'optioneel',
      'booking.name.placeholder': 'Uw naam',
      'booking.email.placeholder': 'u@voorbeeld.be',
      'booking.note.placeholder': 'Adres, staat van de woning, aantal kamers en datum van sleuteloverdracht…',
      'booking.contact.note': 'Om de afspraak te kunnen bevestigen, vult u minstens een telefoonnummer of e-mailadres in.',
      'booking.submit': 'Mijn aanvraag verzenden',
      'booking.success.title': 'Uw formulier is verzonden.',
      'booking.success.body': 'Bedankt. Ons team neemt zo snel mogelijk contact met u op.',
      'booking.error': 'Controleer de ingevulde gegevens.',
      'faq.kicker': 'Veelgestelde vragen',
      'faq.title': 'Eenvoudig, duidelijk,',
      'faq.emphasis': 'zonder verrassingen.',
      'faq.intro': 'Duidelijke antwoorden voordat we beginnen.',
      'faq.1.question': 'Reinigen jullie na een verhuis?',
      'faq.1.answer': 'Ja. We bereiden de lege woning voor op de plaatsbeschrijving, sleuteloverdracht of volgende bewoner.',
      'faq.2.question': 'Kunnen jullie meerdere appartementen behandelen?',
      'faq.2.answer': 'Ja. We organiseren de schoonmaak per lot volgens de opleverplanning van het project.',
      'faq.3.question': 'Hoe krijg ik een prijs?',
      'faq.3.answer': 'Stuur het adres, enkele foto’s, de geschatte oppervlakte en de gewenste datum.',
      'contact.kicker': 'Vertel ons over uw woning',
      'contact.title': 'Komt de sleuteloverdracht dichterbij?',
      'contact.emphasis': 'Ontvang snel een antwoord.',
      'contact.body': '<p>Stuur het adres, enkele foto’s, de geschatte oppervlakte en de gewenste datum. Professionele klanten testen ons aan -50% op een eerste proefappartement.</p>',
      'contact.whatsapp': 'WhatsApp',
      'contact.email': 'E-mail',
      'contact.phone': 'Telefoon',
      'contact.call': 'Bel ons',
      'footer.subtitle': 'Opleveringsschoonmaak van woningen',
      'footer.phrase': 'Na verhuis. Na bouwwerken. Klaar voor de sleuteloverdracht.',
      'footer.services': 'Diensten',
      'footer.email': 'E-mail'
    },
    en: {
      'language.label': 'Language',
      'hero.kicker': 'Ready for key handover',
      'hero.title': 'Homes ready',
      'hero.emphasis': 'to return, rent or deliver.',
      'hero.body': '<p>After a move, renovation or construction project, Clean Living prepares apartments and houses for inspection or handover.</p>',
      'hero.primary': 'Get a quick quote',
      'hero.appointment': 'Schedule the cleaning',
      'hero.offer.label': 'first pilot apartment',
      'hero.scope': 'Move-out · Post-construction',
      'hero.contact.email': 'Email',
      'hero.contact.phone': 'Phone',
      'hero.contact.hours': 'Opening hours',
      'hero.contact.hours.value': '10:00 AM – 6:00 PM',
      'hero.trust.1': 'Quick quote',
      'hero.trust.2': 'Flexible scheduling',
      'hero.trust.3': 'Final quality check',
      'hero.image.alt': 'New apartment building with homes being prepared for handover by Clean Living',
      'services.title': 'Two key moments. One complete reset.',
      'services.intro': 'End-of-tenancy cleaning for a smooth key return, and post-construction cleaning for delivery-ready homes.',
      'services.1.kicker': 'End of tenancy',
      'services.1.title': 'Ready for the move-out inspection.',
      'services.1.body': '<p>After a tenant leaves, we deep-clean the empty home for key return or the next occupant.</p>',
      'services.1.feature.1': 'Kitchen and bathrooms',
      'services.1.feature.2': 'Floors and skirting boards',
      'services.1.feature.3': 'Accessible windows',
      'services.1.feature.4': 'Empty cupboards',
      'services.2.kicker': 'After construction',
      'services.2.title': 'Ready for handover.',
      'services.2.body': '<p>We remove fine dust, marks and residue after construction or renovation, before apartments are delivered.</p>',
      'services.2.feature.1': 'Fine construction dust',
      'services.2.feature.2': 'Worksite marks',
      'services.2.feature.3': 'Floors and glazing',
      'services.2.feature.4': 'Final quality check',
      'services.3.kicker': 'Deep finishing',
      'services.3.title': 'Visible details make the difference.',
      'services.3.body': '<p>We degrease, descale and clean the areas that shape the final impression of a home.</p>',
      'services.3.feature.1': 'Kitchen',
      'services.3.feature.2': 'Bathrooms',
      'services.3.feature.3': 'Doors and switches',
      'services.3.feature.4': 'Visible finishes',
      'services.4.kicker': 'Complete developments',
      'services.4.title': 'Multiple homes, one clear schedule.',
      'services.4.body': '<p>For developers and contractors, we coordinate cleaning by lot and according to handover dates.</p>',
      'services.4.feature.1': 'Lot-by-lot planning',
      'services.4.feature.2': 'Handover schedule',
      'services.4.feature.3': 'Check per home',
      'services.4.feature.4': 'One contact person',
      'entrance.kicker': 'Key handover is approaching',
      'entrance.title': 'A clean home',
      'entrance.emphasis': 'down to the details.',
      'entrance.body': 'We prepare the visible and most demanding areas for inspection, rental or final delivery.',
      'entrance.item.1': 'Kitchen & bathrooms',
      'entrance.item.2': 'Floors & skirting boards',
      'entrance.item.3': 'Windows & doors',
      'entrance.image.alt': 'Two Clean Living employees preparing a home for key handover',
      'entrance.caption': 'Ready for inspection or handover.',
      'method.image.alt': 'Clean Living team completing a post-construction clean',
      'method.kicker': 'Our method',
      'method.title': 'A team that prepares every home',
      'method.emphasis': 'for its next step.',
      'method.body': '<p>We work around your key return or handover date, with a clear scope and careful control of the finishing details.</p>',
      'method.step.1.title': 'Address, photos & date',
      'method.step.1.body': 'Share the property, its current condition and your deadline.',
      'method.step.2.title': 'Scope & price',
      'method.step.2.body': 'We clearly confirm the areas, service and quote.',
      'method.step.3.title': 'Cleaning & quality check',
      'method.step.3.body': 'Our team resets the home and checks the visible finishes.',
      'routine.kicker': 'A complete property reset',
      'routine.title': 'From construction dust to key-ready home.',
      'routine.intro': 'A structured service for returning, renting or delivering a clean home.',
      'routine.1.title': 'Remove dust',
      'routine.1.body': 'Walls, skirting boards, doors and surfaces.',
      'routine.2.title': 'Degrease',
      'routine.2.body': 'Kitchen, bathrooms and stubborn marks.',
      'routine.3.title': 'Wash',
      'routine.3.body': 'Floors and accessible glazing.',
      'routine.4.title': 'Inspect',
      'routine.4.body': 'Room by room before key handover.',
      'booking.kicker': 'Schedule the service',
      'booking.title': 'Choose the time',
      'booking.emphasis': 'that fits your deadline.',
      'booking.intro': 'Suggest a date and time before your inspection or handover. For professional projects, the first pilot apartment is 50% off.',
      'booking.confirmation': 'The time becomes final once it has been confirmed by our team.',
      'booking.date': 'Preferred date',
      'booking.time': 'Preferred time',
      'booking.service': 'Service',
      'booking.service.placeholder': 'Choose a service',
      'booking.service.moveout': 'End of tenancy / move-out',
      'booking.service.construction': 'Post-construction / renovation',
      'booking.service.multiunit': 'Multiple homes to deliver',
      'booking.size': 'Approximate size',
      'booking.size.placeholder': 'E.g. 85 m²',
      'booking.name': 'Name',
      'booking.phone': 'Phone',
      'booking.email': 'Email address',
      'booking.note': 'Additional note',
      'booking.optional': 'optional',
      'booking.name.placeholder': 'Your name',
      'booking.email.placeholder': 'you@example.com',
      'booking.note.placeholder': 'Address, property condition, number of rooms and key handover date…',
      'booking.contact.note': 'To confirm the appointment, please provide at least a phone number or email address.',
      'booking.submit': 'Send my request',
      'booking.success.title': 'Your form has been sent.',
      'booking.success.body': 'Thank you. Our team will contact you as soon as possible.',
      'booking.error': 'Please check the information provided.',
      'faq.kicker': 'Frequently asked questions',
      'faq.title': 'Simple, clear,',
      'faq.emphasis': 'with no surprises.',
      'faq.intro': 'Straightforward answers before we begin.',
      'faq.1.question': 'Do you clean after a move?',
      'faq.1.answer': 'Yes. We prepare the empty home for inspection, key return or the next occupant.',
      'faq.2.question': 'Can you handle several apartments?',
      'faq.2.answer': 'Yes. We can schedule the work by lot according to the project handover plan.',
      'faq.3.question': 'How do I get a price?',
      'faq.3.answer': 'Send the address, a few photos, approximate size and preferred date.',
      'contact.kicker': 'Tell us about your property',
      'contact.title': 'Is a key handover approaching?',
      'contact.emphasis': 'Get a quick response.',
      'contact.body': '<p>Send the address, a few photos, the approximate size and preferred date. Professional clients can test us at 50% off on a first pilot apartment.</p>',
      'contact.whatsapp': 'WhatsApp',
      'contact.email': 'Email',
      'contact.phone': 'Phone',
      'contact.call': 'Call us',
      'footer.subtitle': 'Property handover cleaning',
      'footer.phrase': 'After moving. After construction. Ready for the keys.',
      'footer.services': 'Services',
      'footer.email': 'Email'
    }
  };

  var languageMeta = {
    fr: { title: 'Clean Living — Fin de location & après chantier', selector: 'Choisir la langue', menu: { home: 'Accueil', catalog: 'Services', contact: 'Contact', more: 'Plus' }, whatsapp: 'Bonjour Clean Living, je souhaite un devis pour un nettoyage de fin de location ou après chantier.', emailSubject: 'Demande de devis remise en état Clean Living' },
    nl: { title: 'Clean Living — Einde huur & opleveringsschoonmaak', selector: 'Kies uw taal', menu: { home: 'Startpagina', catalog: 'Diensten', contact: 'Contact', more: 'Meer' }, whatsapp: 'Hallo Clean Living, ik wil graag een offerte voor een eindschoonmaak na huur of bouwwerken.', emailSubject: 'Offerte voor opleveringsschoonmaak Clean Living' },
    en: { title: 'Clean Living — Move-out & post-construction cleaning', selector: 'Choose your language', menu: { home: 'Home', catalog: 'Services', contact: 'Contact', more: 'More' }, whatsapp: 'Hello Clean Living, I would like a quote for move-out or post-construction cleaning.', emailSubject: 'Clean Living property handover quote' }
  };

  function supportedLanguage(value) {
    var language = String(value || '').toLowerCase().split('-')[0];
    return language === 'fr' || language === 'nl' || language === 'en' ? language : null;
  }

  function savedLanguage() {
    try { return supportedLanguage(window.localStorage.getItem('clean-living-language')); }
    catch { return null; }
  }

  function detectedLanguage() {
    var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (var index = 0; index < languages.length; index += 1) {
      var language = supportedLanguage(languages[index]);
      if (language) return language;
    }
    return 'fr';
  }

  function languageGateWasCompleted() {
    try { return window.sessionStorage.getItem('clean-living-language-entered') === 'true'; }
    catch { return false; }
  }

  function showLanguageGate() {
    var gate = document.querySelector('[data-cl-language-gate]');
    if (!gate) return;
    gate.hidden = false;
    gate.classList.remove('is-closing');
    gate.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cl-language-gate-open');
    window.setTimeout(function () {
      var preferred = gate.querySelector('[data-cl-language="' + (globalThis.cleanLivingLanguage || 'fr') + '"]');
      if (preferred) preferred.focus();
    }, 80);
  }

  function hideLanguageGate(immediate) {
    var gate = document.querySelector('[data-cl-language-gate]');
    if (!gate) return;
    document.body.classList.remove('cl-language-gate-open');
    gate.setAttribute('aria-hidden', 'true');
    if (immediate) {
      gate.hidden = true;
      gate.classList.remove('is-closing');
      return;
    }
    gate.classList.add('is-closing');
    window.setTimeout(function () {
      gate.hidden = true;
      gate.classList.remove('is-closing');
    }, 280);
  }

  function resetPageToTop() {
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) pageWrapper.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);

    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function translatedValue(language, key) {
    if (language === 'fr') return null;
    return translations[language] && Object.prototype.hasOwnProperty.call(translations[language], key) ? translations[language][key] : null;
  }

  function translateText(language) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n]'), function (element) {
      if (typeof element.dataset.clOriginalText === 'undefined') element.dataset.clOriginalText = element.textContent;
      var value = translatedValue(language, element.getAttribute('data-cl-i18n'));
      element.textContent = value === null ? element.dataset.clOriginalText : value;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n-html]'), function (element) {
      if (typeof element.dataset.clOriginalHtml === 'undefined') element.dataset.clOriginalHtml = element.innerHTML;
      var value = translatedValue(language, element.getAttribute('data-cl-i18n-html'));
      element.innerHTML = value === null ? element.dataset.clOriginalHtml : value;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n-placeholder]'), function (element) {
      if (typeof element.dataset.clOriginalPlaceholder === 'undefined') element.dataset.clOriginalPlaceholder = element.getAttribute('placeholder') || '';
      var value = translatedValue(language, element.getAttribute('data-cl-i18n-placeholder'));
      element.setAttribute('placeholder', value === null ? element.dataset.clOriginalPlaceholder : value);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n-alt]'), function (element) {
      if (typeof element.dataset.clOriginalAlt === 'undefined') element.dataset.clOriginalAlt = element.getAttribute('alt') || '';
      var value = translatedValue(language, element.getAttribute('data-cl-i18n-alt'));
      element.setAttribute('alt', value === null ? element.dataset.clOriginalAlt : value);
    });
  }

  function translateNavigation(language) {
    var meta = languageMeta[language];
    Array.prototype.forEach.call(document.querySelectorAll('.menu-drawer__menu-item-text, .menu-list__link-title'), function (element) {
      if (!element.dataset.clMenuKey) {
        var value = element.textContent.trim().toLowerCase();
        if (value === 'home' || value === 'accueil' || value === 'startpagina') element.dataset.clMenuKey = 'home';
        if (value === 'catalog' || value === 'catalogue' || value === 'services' || value === 'catalogus' || value === 'diensten') element.dataset.clMenuKey = 'catalog';
        if (value === 'contact') element.dataset.clMenuKey = 'contact';
        if (value === 'more' || value === 'plus' || value === 'meer') element.dataset.clMenuKey = 'more';
      }
      if (element.dataset.clMenuKey && meta.menu[element.dataset.clMenuKey] && element.textContent !== meta.menu[element.dataset.clMenuKey]) element.textContent = meta.menu[element.dataset.clMenuKey];
    });
  }

  function translateLinks(language) {
    var meta = languageMeta[language];
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="wa.me"]'), function (anchor) {
      if (!anchor.dataset.clOriginalHref) anchor.dataset.clOriginalHref = anchor.getAttribute('href');
      var original = anchor.dataset.clOriginalHref;
      anchor.setAttribute('href', original.indexOf('text=') === -1 ? original : original.split('?')[0] + '?text=' + encodeURIComponent(meta.whatsapp));
    });
    Array.prototype.forEach.call(document.querySelectorAll('a[href^="mailto:"]'), function (anchor) {
      if (!anchor.dataset.clOriginalHref) anchor.dataset.clOriginalHref = anchor.getAttribute('href');
      var original = anchor.dataset.clOriginalHref;
      anchor.setAttribute('href', original.indexOf('subject=') === -1 ? original : original.split('?')[0] + '?subject=' + encodeURIComponent(meta.emailSubject));
    });
  }

  function applyLanguage(value) {
    var language = supportedLanguage(value) || 'fr';
    globalThis.cleanLivingLanguage = language;
    document.documentElement.setAttribute('lang', language);
    document.title = languageMeta[language].title;
    translateText(language);
    translateNavigation(language);
    window.setTimeout(function () { if (globalThis.cleanLivingLanguage === language) translateNavigation(language); }, 350);
    window.setTimeout(function () { if (globalThis.cleanLivingLanguage === language) translateNavigation(language); }, 1200);
    translateLinks(language);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-language]'), function (button) {
      var active = button.getAttribute('data-cl-language') === language;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-language-switcher]'), function (switcher) { switcher.setAttribute('aria-label', languageMeta[language].selector); });
    Array.prototype.forEach.call(document.querySelectorAll('input[type="date"], input[type="time"]'), function (field) { field.setAttribute('lang', language); });
  }

  function bindLanguageButtons(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cl-language]'), function (button) {
      if (button.dataset.clLanguageBound === 'true') return;
      button.dataset.clLanguageBound = 'true';
      button.addEventListener('click', function () {
        var language = supportedLanguage(button.getAttribute('data-cl-language')) || 'fr';
        try { window.localStorage.setItem('clean-living-language', language); } catch { /* Storage may be disabled. */ }
        try { window.sessionStorage.setItem('clean-living-language-entered', 'true'); } catch { /* Storage may be disabled. */ }
        applyLanguage(language);
        resetPageToTop();
        hideLanguageGate(false);
        window.requestAnimationFrame(resetPageToTop);
        window.setTimeout(resetPageToTop, 320);
      });
    });
  }

  function initLanguage(scope) {
    bindLanguageButtons(scope || document);
    applyLanguage(globalThis.cleanLivingLanguage || savedLanguage() || detectedLanguage());
    if (languageGateWasCompleted()) hideLanguageGate(true);
    else showLanguageGate();
  }

  globalThis.CleanLivingLocale = { set: applyLanguage, get: function () { return globalThis.cleanLivingLanguage; } };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initLanguage(document); }, { once: true });
  } else {
    initLanguage(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initLanguage(event.target); });
})();

